const faqSection = $('.faq-list-section-parent');
const faqFloatMenuParent = $('.list-float-menu-parent');

const faqList = $('.faq-list-parent');
const faqTypes = $('.faq-list-type-parent');
const searchParent = $('.faq-search-parent');
const searchInput = $('.faq-search-input');

if (!isDesktop()) {
  faqSection.append(searchParent);
}

$(window).on('deviceChange', function () {
  if (!isDesktop()) {
    faqSection.append(searchParent);
  } else {
    faqFloatMenuParent.prepend(searchParent);
  }
});

const checkIsRelative = (query, entity) => {
  if (!query) return true;

  /*
  const words = query
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  if (!words.length) return true;
  */

  const data = entity.data();

  const searchableText = [
    data.faqType,
    data.faqQuestion,
    data.faqAnswer
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  //return words.every(word => searchableText.includes(word));
  return searchableText.includes(query);
}

searchInput.on('input', function () {
  const query = $(this).val().toLowerCase();

  if (query == '') {
    faqTypes.each(function () {
      const faqEntities = $(this).find('.faq-entity');
      faqEntities.each(function () {
        const entity = $(this);
        entity.css('display', 'block');
      });
      $(this).css('display', 'flex');
    });
  } else {
    faqTypes.each(function (index) {
      const faqEntities = $(this).find('.faq-entity');
      let visibleEntites = 0;
      faqEntities.each(function (jindex) {
        const entity = $(this);
        if(index == 0 && jindex == 0){
          checkIsRelative(query, entity);
        }
        if(checkIsRelative(query, entity)){
          visibleEntites += 1;
          entity.css('display', 'block');
        } else {
          entity.css('display', 'none');
        }
      });
      if (visibleEntites > 0) {
        $(this).css('display', 'flex');
      } else {
        $(this).css('display', 'none');
      }
    });
  }
});
